import React from "react";
import Home from "./pages/Home";
import HealingAndTherapies from "./pages/HealingAndTherapies";
import TrainingAndExperiences from "./pages/TrainingAndExperiences";
import OnlineSessions from "./pages/OnlineSessions";
import Courses from "./pages/Courses";
import SoundHealingJourney from "./pages/SoundHealingJourney";
import YogaAndMeditation from "./pages/YogaAndMeditation";
import EventsAndRetreats from "./pages/EventsAndRetreats";
import {BrowserRouter, Routes, Route} from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ContactPage from "./pages/ContactPage";

function App() {
  return (    
    <div>
      <Header />      
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home/>} />
      <Route path="/home" element={<Home/>} />
      <Route path="/healing-and-therapies" element={<HealingAndTherapies/>} />
      <Route path="/training-and-experiences" element={<TrainingAndExperiences/>} />
      <Route path="/online-sessions" element={<OnlineSessions/>} />
      <Route path="/courses" element={<Courses/>} />
      <Route path="/sound-healing-journey" element={<SoundHealingJourney/>} />
      <Route path="/yoga-and-meditation" element={<YogaAndMeditation/>} />
      <Route path="/events-and-retreats" element={<EventsAndRetreats/>} />
      <Route path="/contact" element={<ContactPage/>} />
    </Routes>
    </BrowserRouter>
    <Footer />
    </div>
  )
}

export default App